import * as c from '../constants/RefundExamConstants'
import template from './template'

const refundExamInitialState = {
  examSearch: {
    fetching: false,
    fetched: false,
    error: null,
    exams: [],
  },
  submit: {
    fetching: false,
    fetched: false,
    error: null,
  },
}

export const refundExam = (state = refundExamInitialState, { type, payload }) => {
  switch (type) {
    case c.RESET_REFUND_EXAMS_FLOW:
      return refundExamInitialState

    case c.FETCH_EXAMS_FOR_STUDENT_PENDING:
      return {
        ...state,
        examSearch: {
          ...state.examSearch,
          fetching: true,
          fetched: false,
          error: null,
        },
      }

    case c.FETCH_EXAMS_FOR_STUDENT_FULFILLED:
      return {
        ...state,
        examSearch: {
          ...state.examSearch,
          exams: payload,
          fetching: false,
          fetched: true,
          error: null,
        },
      }
    case c.FETCH_EXAMS_FOR_STUDENT_REJECTED:
      return {
        ...state,
        examSearch: {
          ...state.examSearch,
          fetching: false,
          fetched: false,
          error: payload,
        },
      }

    case c.SUBMIT_REFUND_EXAMS_PENDING:
      return {
        ...state,
        submit: {
          ...state.submit,
          fetching: true,
          fetched: false,
          error: null,
        },
      }
    case c.SUBMIT_REFUND_EXAMS_FULFILLED:
      return {
        ...state,
        submit: {
          ...state.submit,
          fetching: false,
          fetched: true,
          error: null,
        },
      }
    case c.SUBMIT_REFUND_EXAMS_REJECTED:
      return {
        ...state,
        submit: {
          ...state.submit,
          fetching: false,
          fetched: false,
          error: payload,
        },
      }

    default:
      return state
  }
}

export const refundedExams = (state, action) => template(state, action, c, 'REFUNDED_EXAMS')
